import templateUrl from './hierarchies.sort.html'
import templateNested from './hierarchies.sort.nested.html'

/**
 * Sort Hierarchies route
 *
 * @namespace routes.AdminHierarchiesSort
 * @type {TmrRoute}
 */
export const route = {
  name: 'admin.hierarchies.sort',
  label: 'ADMIN.HIERARCHIES.SORT.TITLE',
  url: '/hierarchies/sort',
  component: 'tmrAdminHierarchiesSort',
  resolve: {
    hierarchyTree: /*@ngInject*/ Hierarchy => Hierarchy.getTree(),
  },
  accessControl: ['Resource.edit', 'Resource.Hierarchy.edit'],
}

/**
 * Component for {@link routes.tmrAdminHierarchiesSort Sort Hierarchies route}
 *
 * @type {ngComponent}
 */
export const tmrAdminHierarchiesSort = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrAdminHierarchiesSortController',
  bindings: {
    hierarchyTree: '<',
  },
}

/**
 * Controller of component {@link tmrAdminHierarchiesSort}.
 *
 * @type {ngController}
 */
export class tmrAdminHierarchiesSortController {
  static ngType = 'controller'

  constructor(Hierarchy, TmrToast) {
    'ngInject'
    Object.assign(this, { Hierarchy, TmrToast })
  }

  $onInit() {
    this.templateNested = templateNested
    this.treeOptions = {
      dropped: event => {
        event.source.nodeScope.$modelValue.parent =
          event.dest.nodesScope.$nodeScope === null ||
          event.dest.nodesScope.$nodeScope.$modelValue === undefined
            ? null
            : event.dest.nodesScope.$nodeScope.$modelValue
      },
    }
  }

  onSubmit() {
    let hierarchies = []
    this.treeToArray(this.hierarchyTree, hierarchies)
    this.Hierarchy.bulkUpdate(hierarchies).$promise.then(
      () => this.TmrToast.success('ADMIN.HIERARCHIES.SORT.SUCCESS'),
      err => this.TmrToast.exception(err)
    )
  }

  treeToArray(tree, flat) {
    tree.forEach(hierarchy => {
      // Clone hierarchy to avoid recursion in json with hierarchy.parent.children.
      let h = Object.assign(
        {},
        hierarchy,
        hierarchy.parent ? { parent: { id: hierarchy.parent.id } } : null
      )
      flat.push(h)
      this.treeToArray(hierarchy.children, flat)
      delete h.children
    })
  }
}
